import { COP_API_BASE_URL, getAgreementDetailsUrl } from '../../../constants/service-endpoints'
import { extractNumberFromUrl } from '../../../services/agreementNumber'
import { get } from '../../../services/http.service'

export type AgreementDetailsResponse = {
  customerId?: string
  number?: string
  validFrom?: string
  validTo?: string
  status?: string
  legalEntityName?: string
  primaryContact?: {
    firstName?: string | null
    lastName?: string | null
    phone?: string | null
    email?: string | null
    jobTitle?: string | null
  }
  secondaryContact?: {
    firstName?: string | null
    lastName?: string | null
    phone?: string | null
    email?: string | null
    jobTitle?: string | null
  }
  [key: string]: unknown
}

export async function fetchAgreementDetails(
  agreementId?: string,
): Promise<AgreementDetailsResponse | null> {
  try {

    const resolvedAgreementId = agreementId || extractNumberFromUrl()

    if (!resolvedAgreementId) {
      return null
    }
    const url = `${COP_API_BASE_URL}${getAgreementDetailsUrl(resolvedAgreementId)}`
    return await get<AgreementDetailsResponse>(url)
  } catch (error) {
    console.error('[CopAgreementDetails] Failed to fetch agreement details:', error)
    return null
  }
}

export default fetchAgreementDetails